const multiSelectDeleter = (
  val: number | string,
  array: Array<number | string>,
  callback: any
) => {
  const index = array.indexOf(val);
  array.splice(index, 1);
  callback(() => [...array]);
};

export default multiSelectDeleter;
